import IconSettings from '@assets/icons/settings.svg?react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useDashboardWidget from '../../hooks/useDashboardWidget';
import { WidgetProgressProps } from './Dashboard.types';
import { getWidgetType } from './widgetTypes';

const DashboardWidget = ({
 widget,
 onEdit,
}: {
 widget: WidgetProgressProps;

 onEdit: (widget: WidgetProgressProps) => void;
}) => {
 const { t } = useTranslation();
 const { widgetContent, isLoading, totalSum } = useDashboardWidget(widget);
 const widgetType = getWidgetType(widget.type);

 return (
  <Box
   sx={{
    backgroundColor: (theme) => theme.palette.background.paper,
    borderRadius: '8px',
    padding: '20px',
    position: 'relative',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
   }}
  >
   <Box
    sx={{
     display: 'flex',
     alignItems: 'center',
     gap: '8px',
     marginBottom: '16px',
    }}
   >
    <Typography
     className="dashboard-widget-header"
     sx={{ fontSize: '18px', fontWeight: 400, flexGrow: 1, cursor: 'grab' }}
    >
     {widget.title}
    </Typography>{' '}
    <Box sx={{ display: 'flex', gap: 1 }}>
     <Button
      size="small"
      onClick={() => onEdit(widget)}
      sx={{
       color: (theme) => theme.palette.primary.main,
       textTransform: 'none',
       minWidth: 'auto',
       padding: '2px 6px',
      }}
     >
      <IconSettings />
     </Button>
    </Box>
   </Box>{' '}
   <Box
    sx={{
     display: 'flex',
     flexDirection: 'column',
     gap: 2,
     flexGrow: 1,
     height: 'calc(100% - 48px)',
    }}
   >
    {isLoading && (
     <Box
      sx={{
       textAlign: 'center',
       display: 'flex',
       justifyContent: 'center',
       alignItems: 'center',
       height: '100%',
       p: 4,
      }}
     >
      <CircularProgress
       color="primary"
       size={64}
       sx={{ pointerEvents: 'none' }}
      />
     </Box>
    )}{' '}
    {!isLoading &&
     widgetContent.length === 0 &&
     widgetType?.requiresData !== false && (
      <Box
       sx={{
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: 2,
       }}
      >
       <Typography variant="h5">No data found</Typography>
      </Box>
     )}
    {!isLoading &&
     widgetType &&
     widgetType.requiresData &&
     widgetContent.length > 0 && (
      <widgetType.component widgetContent={widgetContent} totalSum={totalSum} />
     )}
    {!isLoading && widgetType && widgetType.requiresData === false && (
     <widgetType.component />
    )}
   </Box>
  </Box>
 );
};
export default DashboardWidget;
